import { render, staticRenderFns } from "./BudgetMonitoring.vue?vue&type=template&id=1511fcf0&scoped=true"
import script from "./BudgetMonitoring.vue?vue&type=script&lang=js"
export * from "./BudgetMonitoring.vue?vue&type=script&lang=js"
import style0 from "./BudgetMonitoring.vue?vue&type=style&index=0&id=1511fcf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1511fcf0",
  null
  
)

export default component.exports